<!-- when a primary type is selected we do not have more then 50 makes for a primary type just no way -->
<ng-container *ngIf="makes?.length < 50">
  <h4>{{ primaryType }} makes in {{ cityState }}</h4>
  <div class="row">
    <div class="col-6" *ngFor="let make of makes">
      <a [routerLink]="getMakeRouterUrl(make.value)" routerLinkActive="bold" class="text-decoration-none make-link d-flex margin-left-for-image">
        <span>{{ make.value }}</span>
        <span class="text-grey ml-auto">({{ make.count }})</span>
      </a>
    </div>
  </div>
</ng-container>
